export interface Branding { companyName: string; logoUrl?: string; primaryColor: string; secondaryColor?: string; themePreset?: string; footer?: string }
export function safeLogo(value?: string): string | undefined {
  if (!value || value.length > 2_000_000) return undefined;
  if (value.startsWith('https://')) { try { const url = new URL(value); return url.hostname && !url.username && !url.password ? value : undefined; } catch { return undefined; } }
  const match = /^data:image\/(png|jpeg|gif|webp);base64,([A-Za-z0-9+/]+={0,2})$/.exec(value);
  if (!match || match[2].length % 4 !== 0) return undefined;
  try {
    const bytes = atob(match[2]); if (bytes.length < 12 || btoa(bytes) !== match[2]) return undefined;
    const valid = match[1] === 'png' ? bytes.startsWith('\x89PNG\r\n\x1a\n') : match[1] === 'jpeg' ? bytes.startsWith('\xff\xd8\xff') : match[1] === 'gif' ? /^(GIF87a|GIF89a)/.test(bytes) : bytes.startsWith('RIFF') && bytes.slice(8, 12) === 'WEBP';
    return valid ? value : undefined;
  } catch { return undefined; }
}
